/* tslint:disable */
/* eslint-disable */
/**
 * re-order
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddArticleToSalesWrapRequest,
  SalesWrap,
  SalesWrapPagable,
} from '../models';
import {
    AddArticleToSalesWrapRequestFromJSON,
    AddArticleToSalesWrapRequestToJSON,
    SalesWrapFromJSON,
    SalesWrapToJSON,
    SalesWrapPagableFromJSON,
    SalesWrapPagableToJSON,
} from '../models';

export interface AddArticleToSalesWrapOperationRequest {
    id: string;
    addArticleToSalesWrapRequest: AddArticleToSalesWrapRequest;
}

export interface ConfirmSalesWrapRequest {
    id: string;
}

export interface GetSalesOrderRequest {
    id: string;
}

export interface GetSalesOrderScanRequest {
    id: string;
    scanned: string;
}

export interface GetSalesOrdersRequest {
    limit?: number;
    page?: number;
    sortBy?: string;
    orderBy?: GetSalesOrdersOrderByEnum;
}

export interface IncrementArticleAmountRequest {
    id: string;
    articleId: string;
    amount: string;
    batch?: string;
}

export interface SetArticleAmountRequest {
    id: string;
    articleId: string;
    amount: string;
    batch?: string;
}

/**
 * 
 */
export class SalesOrderApi extends runtime.BaseAPI {

    /**
     * Fügt einen Artikel zu einem SalesWrap hinzu
     */
    async addArticleToSalesWrapRaw(requestParameters: AddArticleToSalesWrapOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SalesWrap>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling addArticleToSalesWrap.');
        }

        if (requestParameters.addArticleToSalesWrapRequest === null || requestParameters.addArticleToSalesWrapRequest === undefined) {
            throw new runtime.RequiredError('addArticleToSalesWrapRequest','Required parameter requestParameters.addArticleToSalesWrapRequest was null or undefined when calling addArticleToSalesWrap.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/sales/{id}/article`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddArticleToSalesWrapRequestToJSON(requestParameters.addArticleToSalesWrapRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SalesWrapFromJSON(jsonValue));
    }

    /**
     * Fügt einen Artikel zu einem SalesWrap hinzu
     */
    async addArticleToSalesWrap(requestParameters: AddArticleToSalesWrapOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SalesWrap> {
        const response = await this.addArticleToSalesWrapRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Liefert ein Order
     */
    async confirmSalesWrapRaw(requestParameters: ConfirmSalesWrapRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SalesWrap>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling confirmSalesWrap.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/sales/{id}/confirm`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SalesWrapFromJSON(jsonValue));
    }

    /**
     * Liefert ein Order
     */
    async confirmSalesWrap(requestParameters: ConfirmSalesWrapRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SalesWrap> {
        const response = await this.confirmSalesWrapRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Liefert ein Order
     */
    async getSalesOrderRaw(requestParameters: GetSalesOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SalesWrap>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSalesOrder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/sales/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SalesWrapFromJSON(jsonValue));
    }

    /**
     * Liefert ein Order
     */
    async getSalesOrder(requestParameters: GetSalesOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SalesWrap> {
        const response = await this.getSalesOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Liefert ein Order
     */
    async getSalesOrderScanRaw(requestParameters: GetSalesOrderScanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SalesWrap>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSalesOrderScan.');
        }

        if (requestParameters.scanned === null || requestParameters.scanned === undefined) {
            throw new runtime.RequiredError('scanned','Required parameter requestParameters.scanned was null or undefined when calling getSalesOrderScan.');
        }

        const queryParameters: any = {};

        if (requestParameters.scanned !== undefined) {
            queryParameters['scanned'] = requestParameters.scanned;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/sales/{id}/scanArticle`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SalesWrapFromJSON(jsonValue));
    }

    /**
     * Liefert ein Order
     */
    async getSalesOrderScan(requestParameters: GetSalesOrderScanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SalesWrap> {
        const response = await this.getSalesOrderScanRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Liefert alle SalesOrders
     */
    async getSalesOrdersRaw(requestParameters: GetSalesOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SalesWrapPagable>> {
        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        if (requestParameters.orderBy !== undefined) {
            queryParameters['orderBy'] = requestParameters.orderBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/sales`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SalesWrapPagableFromJSON(jsonValue));
    }

    /**
     * Liefert alle SalesOrders
     */
    async getSalesOrders(requestParameters: GetSalesOrdersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SalesWrapPagable> {
        const response = await this.getSalesOrdersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Liefert ein Order
     */
    async incrementArticleAmountRaw(requestParameters: IncrementArticleAmountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SalesWrap>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling incrementArticleAmount.');
        }

        if (requestParameters.articleId === null || requestParameters.articleId === undefined) {
            throw new runtime.RequiredError('articleId','Required parameter requestParameters.articleId was null or undefined when calling incrementArticleAmount.');
        }

        if (requestParameters.amount === null || requestParameters.amount === undefined) {
            throw new runtime.RequiredError('amount','Required parameter requestParameters.amount was null or undefined when calling incrementArticleAmount.');
        }

        const queryParameters: any = {};

        if (requestParameters.articleId !== undefined) {
            queryParameters['articleId'] = requestParameters.articleId;
        }

        if (requestParameters.amount !== undefined) {
            queryParameters['amount'] = requestParameters.amount;
        }

        if (requestParameters.batch !== undefined) {
            queryParameters['batch'] = requestParameters.batch;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/sales/{id}/incrementAmount`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SalesWrapFromJSON(jsonValue));
    }

    /**
     * Liefert ein Order
     */
    async incrementArticleAmount(requestParameters: IncrementArticleAmountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SalesWrap> {
        const response = await this.incrementArticleAmountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Liefert ein Order
     */
    async setArticleAmountRaw(requestParameters: SetArticleAmountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SalesWrap>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling setArticleAmount.');
        }

        if (requestParameters.articleId === null || requestParameters.articleId === undefined) {
            throw new runtime.RequiredError('articleId','Required parameter requestParameters.articleId was null or undefined when calling setArticleAmount.');
        }

        if (requestParameters.amount === null || requestParameters.amount === undefined) {
            throw new runtime.RequiredError('amount','Required parameter requestParameters.amount was null or undefined when calling setArticleAmount.');
        }

        const queryParameters: any = {};

        if (requestParameters.articleId !== undefined) {
            queryParameters['articleId'] = requestParameters.articleId;
        }

        if (requestParameters.amount !== undefined) {
            queryParameters['amount'] = requestParameters.amount;
        }

        if (requestParameters.batch !== undefined) {
            queryParameters['batch'] = requestParameters.batch;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/sales/{id}/setAmount`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SalesWrapFromJSON(jsonValue));
    }

    /**
     * Liefert ein Order
     */
    async setArticleAmount(requestParameters: SetArticleAmountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SalesWrap> {
        const response = await this.setArticleAmountRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetSalesOrdersOrderByEnum = {
    Asc: 'asc',
    Desc: 'desc',
    UnknownDefaultOpenApi: '11184809'
} as const;
export type GetSalesOrdersOrderByEnum = typeof GetSalesOrdersOrderByEnum[keyof typeof GetSalesOrdersOrderByEnum];
